<header id="header" class="section page-header jumbotron-creative">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">

        <a class="navbar-brand" routerLink="/"><img class="brand-img" src="assets/images/{{epimelitirio}}.jpg" alt=""
                max-height="25" /></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03"
            aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse nav-context-padding" id="navbarTogglerDemo03">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <ng-template [ngIf]="!(isSigned)">
                    <li class="nav-item">
                        <a class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                            (click)="jobsList()">
                            ΘΕΣΕΙΣ ΕΡΓΑΣΙΑΣ
                        </a>
                    </li>
                    <!-- <li class="nav-item dropdown">
                        <button
                            class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                            id="navbarDropdown" role="button" (click)="onUnsignedCandidatesList()">
                            ΥΠΟΨΗΦΙΟΙ
                        </button>
                    </li> -->
                    <li class="nav-item">
                        <button id="connectButton"
                            class="small-screens-header-buttons button button-xs button-primary button-icon-left"
                            (click)="login()">
                            <span class="icon mdi mdi-import myIcon"></span>ΣΥΝΔΕΣΗ
                        </button>
                    </li>
                </ng-template>
                <ng-template [ngIf]="(isSigned) && authService.isCompany()">
                    <li class="nav-item">
                        <a class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                            (click)="jobsList()">
                            ΘΕΣΕΙΣ ΕΡΓΑΣΙΑΣ
                        </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                            (click)="candidatesList()" id="navbarDropdown" role="button">
                            ΥΠΟΨΗΦΙΟΙ
                        </a>
                    </li>
                    <li *ngIf="authService.isValidCompany;else notValidCompany" class="nav-item dropdown">
                        <a style="text-transform: capitalize;"
                            class="small-screens-header-buttons anchorHeader nav-link dropdown-toggle button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original context-break"
                            id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <span class="icon mdi mdi-account"></span>{{authService.signedName}}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li class="dropdown-item myDropItem" (click)="myAccount()">Προφίλ Εταιρείας</li>
                    <li class="dropdown-item  myDropItem" (click)="jobListCompany()">Θέσεις εργασίας της εταιρείας</li>
                    <li class="dropdown-item  myDropItem" (click)="jobPost()">Ανάρτηση θέσης εργασίας</li>
        </div>
        </li>
        <ng-template #notValidCompany>
            <li class="nav-item" (click)="myAccount()">
                <a style="text-transform: capitalize;"
                    class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original context-break">
                    <span class="icon mdi mdi-account"></span>{{authService.signedName}}
                </a>
            </li>
        </ng-template>
        <li>
            <button
                class="small-screens-header-buttons button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                (click)="cancel()">
                <span class="icon mdi mdi-account"></span>ΑΠΟΣΥΝΔΕΣΗ
            </button>
        </li>
        </ng-template>
        <ng-template [ngIf]="(isSigned) && authService.isCandidate()">
            <li class="nav-item">
                <a class="small-screens-header-buttons anchorHeader nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                    (click)="jobsList()">
                    ΘΕΣΕΙΣ ΕΡΓΑΣΙΑΣ
                </a>
            </li>
            <li *ngIf="authService.isValidCandidate;else notValidCandidate" class="nav-item dropdown">
                <a style="text-transform: capitalize;"
                    class="small-screens-header-buttons anchorHeader button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original nav-link dropdown-toggle button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original context-break"
                    id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="icon mdi mdi-account"></span>{{authService.signedName}}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li class="dropdown-item myDropItem" (click)="myAccount()">Το βιογραφικό μου</li>
            <li class="dropdown-item  myDropItem" (click)="myApplies()">Οι αιτήσεις μου</li>
            <li class="dropdown-item  myDropItem" (click)="myConfig()">Ρυθμίσεις Ειδοποιήσεων</li>
            </div>
            </li>
            <ng-template #notValidCandidate>
                <li class="nav-item" (click)="myAccount()">
                    <a
                        class="small-screens-header-buttons anchorHeader button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original nav-link button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original">
                        <span class="icon mdi mdi-account"></span>Ο ΛΟΓΑΡΙΑΣΜΟΣ ΜΟΥ
                    </a>
                </li>
            </ng-template>
            <li>
                <button
                    class="small-screens-header-buttons button button-xs button-primary button-icon-left rd-navbar-popup-toggle toggle-original"
                    (click)="cancel()">
                    <span class="icon mdi mdi-account"></span>ΑΠΟΣΥΝΔΕΣΗ
                </button>
            </li>
        </ng-template>
        </ul>
        </div>
    </nav>
</header>
<div id="navbarDecItem" class="jc-decoration">
    <div class="items jc-decoration-item jc-decoration-item-1">
        <svg version="1.1" x="0px" y="0px" viewbox="0 0 1446 970" width="1446" height="970" preserveAspectRatio="none">
            <path
                d="M-0.000,33.000 C-0.000,33.000 80.000,54.000 113.000,83.000 C146.000,112.000 147.000,152.000 183.000,174.000 C219.000,196.000 288.000,172.000 334.000,193.000 C380.000,214.000 379.000,282.000 427.000,317.000 C475.000,352.000 548.000,336.000 588.000,371.000 C628.000,406.000 614.000,483.000 647.000,513.000 C680.000,543.000 786.000,537.000 841.000,587.000 C896.000,637.000 885.000,739.000 932.000,776.000 C979.000,813.000 1026.000,796.000 1069.000,817.000 C1112.000,838.000 1135.000,865.000 1189.000,893.000 C1243.000,921.000 1433.000,970.000 1433.000,970.000 L1446.000,0.000 L-0.000,33.000 Z">
            </path>
        </svg>
    </div>
    <div class="items jc-decoration-item jc-decoration-item-2">
        <svg version="1.1" x="0px" y="0px" viewbox="0 0 1446 970" width="1446" height="970" preserveAspectRatio="none">
            <path
                d="M-0.000,33.000 C-0.000,33.000 80.000,54.000 113.000,83.000 C146.000,112.000 147.000,152.000 183.000,174.000 C219.000,196.000 288.000,172.000 334.000,193.000 C380.000,214.000 379.000,282.000 427.000,317.000 C475.000,352.000 548.000,336.000 588.000,371.000 C628.000,406.000 614.000,483.000 647.000,513.000 C680.000,543.000 786.000,537.000 841.000,587.000 C896.000,637.000 885.000,739.000 932.000,776.000 C979.000,813.000 1026.000,796.000 1069.000,817.000 C1112.000,838.000 1135.000,865.000 1189.000,893.000 C1243.000,921.000 1433.000,970.000 1433.000,970.000 L1446.000,0.000 L-0.000,33.000 Z">
            </path>
        </svg>
    </div>
</div>